<template>
    <modal id="poll-option-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('pollOption')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.POLL_OPTION'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('pollOptions.option_text')"
                        type="text"
                        v-model="formData.option_text"
                        :placeholder="$placeholder('pollOptions.option_text')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'option_text')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('pollQuestion')"
                        list-value-field="question_text"
                        v-model="formData.poll_question_id"
                        :chooseLabel="$t('pollQuestion')"
                        :error-message="$errorMessage(errors, 'poll_question_id')"
                        :required="true"
                        :fetch-url="TENANT_SELECTABLE_POLL_QUESTION"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {TENANT_SELECTABLE_POLL_QUESTION} from "../../../../Config/ApiUrl";


export default {
    name: "PollOptionCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {},
            TENANT_SELECTABLE_POLL_QUESTION,
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData.active_status = formData.active_status ? 1 : 0;
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.POLL_OPTION;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#poll-option-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'poll-option-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#poll-option-modal').modal('hide');
            this.toastAndReload(data.message, 'poll-option-table')
            this.$emit('input', false);
            window.location.reload();
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
